import { Tier } from 'context/AppContext'
import { BookingForm, BookingFormExtra } from 'types/booking'
import { CalendarSlotItem } from 'types/calendar'
import { CategoryApiOutput } from 'types/category'
import { MembershipClient } from 'types/client-membership'
import { CognitoErrorTypes } from 'types/cognito'
import { MembershipItem } from 'types/membership'
import { OrderDTO } from 'types/order'
import { ServiceDiscountType } from 'types/service'
import { Staff, StaffUser } from 'types/staff'
import { TenantIntegration } from 'types/tenant-integration'
import { UserApiResponse } from 'types/user'
import { StaffCardItemProps } from './Service/StaffCardItem'
import { CalendarIntegration } from './Staff/Calendar'

export interface ModalDataAttributes {
    [key: string]:
        | string
        | string[]
        | number
        | boolean
        | Date
        | File
        | Tier
        | ModalDataAttributes
        | ModalDataAttributes[]
        | MembershipItem
        | CategoryApiOutput[]
        | GroupClassAvailabilityApi[]
        | CalendarIntegration
        | CalendarIntegration[]
        | StaffCardItemProps[]
        | CalendarSlotItem
        | Record<string,string>
        | TenantIntegration[]
        | BookingForm & BookingFormExtra
        | Staff
        | StaffUser
        | UserApiResponse
        | MembershipClient[]
        | OrderDTO[]
        | ServiceDiscountType
        | (() => void)
        | CalendarSlotItem[]
}
export interface ModalHook {
    is_open: boolean
    open(): void
    close(): void
    attributes?: ModalDataAttributes
    setAttributes(attributes: ModalDataAttributes): void
}

export type UserModel = {
    id?: string
    uuid?: string
    firstName: string
    lastName: string
    email: string
    phone?: string
    imageUrl?: string
    dateOfBirth?: string
    street1?: string
    street2?: string
    city?: string
    state?: string
    country?: string
    createdAt?: string
    preferredLanguageId?: string
    zip?: string
    timezone?: string
    cognitoId?: string
}

export type SubmitError = {
    name: CognitoErrorTypes
    message: string
}

export enum RecurrenceSchedule {
    NONE = 'NONE',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY_ON_DAY = 'MONTHLY_ON_DAY',
    MONTHLY_ON_DATE = 'MONTHLY_ON_DATE',
}

export type GroupClassAvailabilityApi = {
    id?: string
    date: string
    endTime: string
    serviceId?: string
    startTime: string
    setting?: {
        groupClassId: string
        id: string
        locationId: string
        locationSpaceId?: string
        staffId: string
    }
}
export type GroupClassApi = {
    id?: string
    name?: string
    effectiveDate?: Date | string
    expiryDate?: Date | string
    startTime?: string
    endTime?: string
    recurring?: boolean
    recurrenceSchedule?: RecurrenceSchedule
    dayOfWeek?: DayOfWeek
    duration?: number
    serviceId: string
    groupClassSetting: {
        id?: string
        locationId: string
        locationSpaceId?: string
        staffId: string
    }
    groupClassAvailabilities?: GroupClassAvailabilityApi[]
}

export enum DayOfWeek {
    SUNDAY,
    MONDAY,
    TUESDAY,
    WEDNESDAY,
    THURSDAY,
    FRIDAY,
    SATURDAY,
}

export type GroupClass = {
    id?: string
    date: Date
    day_of_week?: DayOfWeek
    ends_at?: Date
    time: string
    is_recurring: boolean
    location: string
    location_space: string
    repeats?: RecurrenceSchedule
    staff: string
    setting_id?: string
    availabilities?: {
        id?: string
        date: Date
        start_time: string
        end_time?: string
    }[]
    duration?: number
    name?: string
    service_type?: string 
}

export type GroupClassFormItem = { _original: GroupClass } & GroupClass
